import React, {Component} from 'react'

export default class WidgetHeader extends Component {
    render() {
        let title = this.props.title;
        return (
            <div className="row">
                <div className="col-md">
                    <div className="widget-header w-100 clearfix">
                        <div className="float-left widget-header-title">
                            { title ? title : ''}
                        </div>
                        <div className="float-right">
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetHeader.jsx